/**
 * AskBaskyBubble — floating sparkle bubble in bottom-right corner of the app.
 * Shows a "Ask Basky" tooltip for 4 seconds on first visit (per-session), then
 * collapses to a pulse icon. Click → opens the drawer.
 */
import { useState, useEffect } from 'react';
import { Sparkles } from 'lucide-react';
import AskBaskyDrawer from './AskBaskyDrawer';

export default function AskBaskyBubble() {
  const [open, setOpen] = useState(false);
  const [showLabel, setShowLabel] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem('basky_seen') === '1') return;
    setShowLabel(true);
    const t = setTimeout(() => {
      setShowLabel(false);
      sessionStorage.setItem('basky_seen', '1');
    }, 4000);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      <button
        onClick={() => { setOpen(true); setShowLabel(false); }}
        className="fixed bottom-5 right-5 z-40 group flex items-center gap-2 pl-3 pr-4 py-3 rounded-full bg-gradient-to-br from-violet-600 to-indigo-600 text-white shadow-lg hover:shadow-xl hover:scale-105 transition-all"
        aria-label="Ask Basky"
        data-testid="ask-basky-bubble"
      >
        <span className="relative flex h-5 w-5 items-center justify-center">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white opacity-50"></span>
          <Sparkles className="relative h-4 w-4" />
        </span>
        <span className={`text-sm font-medium whitespace-nowrap overflow-hidden transition-all ${showLabel ? 'max-w-[100px] opacity-100' : 'max-w-0 opacity-0 group-hover:max-w-[100px] group-hover:opacity-100'}`}>
          Ask Basky
        </span>
      </button>
      <AskBaskyDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
}
